/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { AxiosResponse } from 'axios'
import hosts from 'config/microServices'
import QueryStringFilter from 'Helpers/QueryStringFilter'
import Usuario from 'Models/cadastros/Usuario'
import { ParamsRequest } from 'Services/__shared/types/resquest'
import ApiService from 'Services/ApiService'
import { ServiceListResponse } from 'Types/ServiceResponse'
import IFormUsuariosFilter from 'Views/Cadastros/Usuarios/IFormUsuariosFilter'

const usuarios = {
  getList: async (filter?: IFormUsuariosFilter, params?: ParamsRequest) => {
    const result: AxiosResponse<ServiceListResponse<Usuario>> =
      await ApiService().get<ServiceListResponse<Usuario>>(
        QueryStringFilter(`${hosts.WS_CADASTRO}/usuario`, filter, params),
      )

    return result
  },

  verificaMestreSistema: async () => {
    const result: AxiosResponse<boolean> = await ApiService().get<
      ServiceListResponse<Usuario>
    >(QueryStringFilter(`${hosts.WS_CADASTRO}/verificaMestreSistema`))

    return result
  },
}

export default usuarios
